import { c, IllustrationFrame, sc, type IllustrationProps } from './Illustration';

/** Home empty state. A wrapped present with a blue bow and a little confetti. */
export function GiftBox(props: IllustrationProps) {
  return (
    <IllustrationFrame {...props}>
      <ellipse cx="80" cy="140" rx="48" ry="7" style={{ fill: sc('border.default') }} />
      <rect x="34" y="70" width="92" height="66" rx="10" style={{ fill: c('berry.400') }} />
      <rect x="28" y="56" width="104" height="22" rx="8" style={{ fill: c('berry.500') }} />
      <rect x="72" y="56" width="16" height="80" style={{ fill: c('gold.400') }} />
      <path d="M80 56c-8-20-34-22-32-6 2 10 22 8 32 6z" style={{ fill: c('blue.500') }} />
      <path d="M80 56c8-20 34-22 32-6-2 10-22 8-32 6z" style={{ fill: c('blue.400') }} />
      <circle cx="80" cy="54" r="7" style={{ fill: c('blue.600') }} />
      <circle cx="26" cy="34" r="4" style={{ fill: c('gold.400') }} />
      <circle cx="136" cy="28" r="3" style={{ fill: c('mint.300') }} />
      <rect
        x="128"
        y="44"
        width="8"
        height="8"
        rx="2"
        transform="rotate(20 132 48)"
        style={{ fill: c('blue.300') }}
      />
      <rect
        x="18"
        y="52"
        width="7"
        height="7"
        rx="2"
        transform="rotate(-15 21 55)"
        style={{ fill: c('berry.300') }}
      />
    </IllustrationFrame>
  );
}
